module.exports = __webpack_public_path__ + "img/arrow_right_circle.3de7d143.svg";